import { ColumnState } from 'ag-grid-community-new';

export const getActualColumnStateFields = (colState: ColumnState[]): ColumnState[] => {
  return colState.map(({ colId, hide, width }) => ({
    colId,
    hide,
    width,
  }));
};
